import { useState } from "react";
import ReactMarkDown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import SwitchButtons from "./SwitchButtons";
const Essay = ({citationsData, essayData, promptsData, isMobile}) => {

    const [onWorksCited, SetOnWorksCited] = useState(true);

    const singleLineTexts = [
        {
            text: 'WORKS CITED',
            content: true
        },
        // {
        //     text: 'PROMPTS CITED',
        //     content: false
        // }
    ];

    const multiLineTexts = [
        {
            text: <>
                WORKS <br/> CITED
            </>,
            content: true
        },
        // {
        //     text: <>
        //         PROMPTS CITED
        //     </>,
        //     content: false
        // }
    ];
    return (
        <>
            <ReactMarkDown rehypePlugins={[rehypeRaw]}>{essayData}</ReactMarkDown>
            <SwitchButtons
                activeContent={onWorksCited}
                setActiveContent={SetOnWorksCited}
                texts={isMobile ? multiLineTexts : singleLineTexts}
            />
            {onWorksCited ? (
                <div className="md-div">
                    <ReactMarkDown rehypePlugins={[rehypeRaw]}>{citationsData}</ReactMarkDown>
                </div>
            ) : (
                <div className="md-div">
                    <ReactMarkDown rehypePlugins={[rehypeRaw]}>{promptsData}</ReactMarkDown>
                </div>
            )}
        </>
    )
};

export default Essay;